import type { ReactNode } from 'react';

import { SnsPlatform } from 'store/apiTypes';

import { Translate } from '@travel/translation';
import { getTextCount } from 'utils/validationHelper';

export const validateUserId = (value: string): ReactNode => {
  const perceivedLength = getTextCount(value);

  if (perceivedLength < 5) {
    return <Translate id="MyReview.Edit.UserID.Validation.CharCountMin" />;
  }

  if (perceivedLength > 30) {
    return <Translate id="MyReview.Edit.UserID.Validation.CharCountMax" />;
  }

  if (!/^[a-zA-Z0-9_.-]+$/.test(value)) {
    return <Translate id="MyReview.Edit.UserID.Validation.IncorrectChar" />;
  }

  return '';
};

export const validateNickname = (value: string): ReactNode => {
  const perceivedLength = getTextCount(value);

  if (perceivedLength < 5) {
    return <Translate id="Review.Common.Nickname.Validation.CharCountMin" />;
  }

  if (perceivedLength > 42) {
    return <Translate id="Review.Common.Nickname.Validation.CharCountMax" />;
  }

  return '';
};

export const validateUserBio = (value: string): ReactNode => {
  const perceivedLength = getTextCount(value);

  if (perceivedLength > 200) {
    return <Translate id="MyReview.Edit.Description.Validation.CharCountMax" />;
  }

  return '';
};

export function trimUrlProtocolSubDomain(path: string, platform?: string): string {
  const REGEX_TIKTOK = /@\{[^}]*\}|@/g;

  if (!path) return '';

  let url = path.replace(/^https?:\/\//, '');

  url = url.replace(/^www\./, '');

  const slashIndex = url.indexOf('/');
  let domain = url;
  let pathname = '';

  if (slashIndex !== -1) {
    domain = url.slice(0, slashIndex);
    pathname = url.slice(slashIndex);
  }

  if (platform === SnsPlatform.TIKTOK) {
    pathname = pathname.replace(REGEX_TIKTOK, '');
  }

  if (pathname === '/{id}') {
    pathname = '/';
  }

  return domain + pathname;
}

export function getPathFromUrl(url: string) {
  const firstSlashIndex = url.indexOf('/');

  return url.substring(firstSlashIndex + 1);
}

export function addProtocolsToUrls(trimUrl: string, url: string) {
  const value = getPathFromUrl(trimUrl);
  const completeUrl = url.replace(/{id}/g, () => value);

  return completeUrl;
}

export function splitDomainAndPath(str: string) {
  const i = str.indexOf('/');

  return i === -1 ? [str, ''] : [str.slice(0, i), str.slice(i + 1)];
}

export const SNS_VALIDATION_LIST = {
  INSTAGRAM: {
    regex: /^[a-zA-Z0-9._]{1,30}$/,
    maxLength: 30,
  },
  TIKTOK: {
    regex: /^[a-zA-Z0-9._]{1,24}$/,
    maxLength: 24,
  },
  X: {
    regex: /^[a-zA-Z0-9_]{1,15}$/,
    maxLength: 15,
  },
  YOUTUBE: {
    regex: /^.{1,30}$/,
    maxLength: 30,
  },
  GOOGLE_MAP: {
    regex: /.{1,}/,
    maxLength: null,
  },
  NOTE: {
    regex: /^[a-z0-9_]{1,16}$/,
    maxLength: 16,
  },
  ROOM: {
    regex: /^[a-zA-Z0-9_]{1,32}$/,
    maxLength: 32,
  },
} as const;
